import React, { lazy } from "react";
import { Route } from "react-router-dom";
import RouteSuspense from "../RouteSuspense";

const AdminDashboard = lazy(() => import("../../pages/adminDashboard/AdminDashboard"));
const AdminClients = lazy(() => import("../../pages/adminDashboard/AdminClients"));
const AdminApprovals = lazy(() => import("../../pages/adminDashboard/AdminApprovals"));
const AdminLogs = lazy(() => import("../../pages/adminDashboard/AdminLogs"));
const NotifInfo = lazy(() => import("../../pages/notification/NotifInfo"));

const AdminLiveRoutes = () => (
  <>
    <Route path="/admin-dashboard" element={<RouteSuspense><AdminDashboard /></RouteSuspense>} />
    <Route path="/admin-dashboard/clients" element={<RouteSuspense><AdminClients /></RouteSuspense>} />
    <Route path="/admin-dashboard/approvals" element={<RouteSuspense><AdminApprovals /></RouteSuspense>} />
    <Route
      path="/admin-dashboard/notifications"
      element={<RouteSuspense><NotifInfo backPath="/admin-dashboard" /></RouteSuspense>}
    />
    <Route path="/admin-dashboard/logs" element={<RouteSuspense><AdminLogs /></RouteSuspense>} />
  </>
);

export default AdminLiveRoutes;
